import React from 'react'
import { useStaticQuery, graphql } from 'gatsby'

import MenuItem from './MenuItem'

import * as S from './styled'

const MenuContainer = () => {
  const data = useStaticQuery(graphql`
    query {
      Menu: allWordpressExecutiveThemeHeader {
        nodes {
          sidebars {
            widgets {
              value {
                name
                items {
                  title
                  url
                  wordpress_children {
                    title
                    url
                  }
                }
              }
            }
          }
        }
      }
    }
  `)

  const menu = data.Menu.nodes[0].sidebars[0].widgets.filter(function(menuHeader) {
    return menuHeader.value.name == "Menu/Header - Desktop"
  });  
  const menuData = menu[0].value.items
  
  return (
    <S.ContainerMenuDesktop
      id='ContainerMenuDesktop-ul'
      className='ContainerMenuDesktop-ul'
      data-testid='containermenudesktop-ul'
    >
      <S.MenuDesktop
        id='MenuDesktop-ul'
        className='MenuDesktop-ul'
        data-testid='menudesktop-ul'
      >
        <MenuItem menuData={menuData} />
      </S.MenuDesktop>
    </S.ContainerMenuDesktop>
  )
}

export default MenuContainer
